import styled from "styled-components";

import TextInputBase from "../TextInput";

const TextArea = styled.div``;

const TextInput = styled(TextInputBase)``;

export { TextInput, TextArea };
